import { Platform, useWindowDimensions } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

export const useResponsiveDimensions = () => {
    const windowDimensions = useWindowDimensions();
    const safeAreaFrame = useSafeAreaFrame();

    // useSafeAreaFrame() is recommended to use when enabling edge-to-edge, that's why we need it for iOS & Android on some places
    // but on web we want to use useWindowDimensions() from react-native
    return Platform.OS === 'web' ? windowDimensions : safeAreaFrame;
};
